import Link from "next/link";
import classnames from "classnames";

import Tag from "@/components/Tag";
import Typography from "@/components/Typography";
import { applicationRoutes } from "@/helpers/applicationRouting";

import styles from "../Tabs.module.scss";
import { DescriptionInterface } from "../Tabs.interface";

const Description: React.FC<DescriptionInterface> = ({
  description,
  tags,
  className,
}) => (
  <div className={classnames(styles.description, className)}>
    <Typography variant="medium" component="p" className={styles.text}>
      {description}
    </Typography>
    <div className={styles.tags}>
      {tags.map(({ title, id, slug }) => (
        <Link
          key={id}
          href={`${applicationRoutes.TAG}[slug]`}
          as={applicationRoutes.TAG + slug}
        >
          <a className={styles.link}>
            <Tag title={title} key={id} className={styles.tag}>
              {title}
            </Tag>
          </a>
        </Link>
      ))}
    </div>
  </div>
);

export default Description;
